import clientConfig from "@template/clientConfig";

export const adobeAccountProvider = () => {
  const { ADOBE_ANALYTICS_ACCOUNT: adobeAccount } = clientConfig.get();

  return adobeAccount;
};
